export const SERVICES = Object.freeze({
  APS: 'aps',
  SELF_SERVICE_REFUELING: 'self_service_refueling',
  CHAIN_STORE: 'chain_store',
  GUEST_ALPR: 'guest_alpr',
});

export const TRANSACTION_TYPES = Object.freeze({
  REFUELING: 'refueling',
  PARKING: 'parking',
  ON_STREET_PARKING: 'on_street_parking',
  LEASE: 'lease',
  REFUELING_PAYMENT: 'refueling_payment',
  PARKING_PAYMENT: 'parking_payment',
  VEHICLE_MAINTENANCE: 'vehicle_maintenance',
  WASH_CAR: 'wash_car',
  VEHICLE_REPAIR: 'vehicle_repair',
  CHARGING: 'charging',
});

export const TRANSACTION_TYPES_NAME = Object.freeze({
  [TRANSACTION_TYPES.REFUELING]: '加油',
  [TRANSACTION_TYPES.PARKING]: '停車',
  [TRANSACTION_TYPES.ON_STREET_PARKING]: '路邊停車',
  [TRANSACTION_TYPES.LEASE]: '月租車位',
  [TRANSACTION_TYPES.REFUELING_PAYMENT]: '加油多元支付',
  [TRANSACTION_TYPES.PARKING_PAYMENT]: '停車多元支付',
  [TRANSACTION_TYPES.VEHICLE_MAINTENANCE]: '汽車美容',
  [TRANSACTION_TYPES.WASH_CAR]: '洗車',
  [TRANSACTION_TYPES.VEHICLE_REPAIR]: '維修保養',
  [TRANSACTION_TYPES.CHARGING]: '充電',
});

export const POI_PAYMENT_TYPES = Object.freeze({
  MOCHIPAY: 'mochipay',
  PASS: 'pass',
  BARCODE_PAYMENT: 'barcode_payment',
  NONE: 'none',
});
